import React from 'react';

class DeviceDbEvents extends React.Component {

    render() {
        return <div>{this.props.earliest} - {this.props.latest}</div>
    }
}

export default DeviceDbEvents;